import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../components/FontAwesomeIcons";
import logoWhite from "../../img/logo_total_white.svg";
import {BookizonPlusLogo} from "./BookizonPlusLogo";
import {BOOKIZON_PLUS_BENEFITS} from "./Constants";
import {BookizonAppManager} from "../../index";
import AppConfig from "../../config/AppConfig";
import AuthAPI from "../../api/AuthAPI";
import FuxEvents from "../../lib/FuxFramework/FuxEvents";
import {NM_IN_APP_BROWSER_DISMISS} from "../../native/NativeMessageHandler";
import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import {AUTHENTICATED_USER_DATA_CHANGE} from "../../const/AppEventsCostants";
import {swal, swalLoading} from "../../helpers/SweetAlertWrapper";

const gradientBackgroundStyle = {
    background: "linear-gradient(to right top, #293069, #383d78, #474a87, #565896, #6566a6, #7373b3, #8180bf, #8f8dcc, #9f9cd9, #aface5, #bfbcf2, #cfccff)",
};

const accentBoxStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.12)"
};

const benefitsCardStyle = {
    backgroundColor: "rgba(0, 0, 0, 0.25)",
    backdropFilter: "blur(6px)"
};

const benefitIconStyle = {
    color: "#7cfdd4"
};

export class BookizonPlusPromoPage extends React.Component {


    constructor(props) {
        super(props);
    }

    componentDidMount() {
        FuxEvents.on(NM_IN_APP_BROWSER_DISMISS, this.handleBrowserDismiss);
    }

    componentWillUnmount() {
        FuxEvents.off(NM_IN_APP_BROWSER_DISMISS, this.handleBrowserDismiss);
    }

    handleActivate = _ => BookizonAppManager.openInAppBrowser(`${AppConfig.webServerUrl}/api/user/subscriptions/info?token=${AuthAPI.getUserAccessToken()}`)

    handleBrowserDismiss = _ => {
        swalLoading('Attendere prego...');
        FuxHTTP.get(`${AppConfig.webServerUrl}/api/user/subscriptions/get-info`,{token: AuthAPI.getUserAccessToken()}, FuxHTTP.RESOLVE_DATA, FuxHTTP.REJECT_MESSAGE)
            .then(data => {
                console.log(data,data.is_bookizon_plus_active)
                if (data.is_bookizon_plus_active){
                    AuthAPI.currentUser = {...AuthAPI.currentUser, is_bookizon_plus_active: true};
                    FuxEvents.emit(AUTHENTICATED_USER_DATA_CHANGE)
                    this.props.onDismiss();
                }
            })
            .finally(_ => swal.safeClose());
    }

    render() {

        return (
            <Page
                active={this.props.active}
                title={"Bookizon Plus"}
                leftIconText={"Indietro"}
                onLeftIconClick={this.props.onDismiss}
                hideNavbar={true}
                navbarBgColor={"transparent"}
                pageContentStyle={gradientBackgroundStyle}
            >
                <div className={"page-navbar container-fluid px-3 py-2"}>
                    <div className="row">
                        <div className="col-3 text-center pr-0 __androidDismissable__"
                             onClick={this.props.onDismiss}
                             style={{fontSize: "1em"}}>
                            <FaSolidIcon name={"chevron-left"}/> <small>Indietro</small>
                        </div>
                        <div className="col text-truncate text-center">
                            <span className="page-title"></span>
                        </div>
                        <div className="col-3 text-center pl-0" style={{fontSize: "1em"}}/>
                    </div>
                </div>
                <div className={"py-5 px-4 px-md-5 text-white d-flex flex-column align-items-center"}>
                    <section className={"text-center mb-4 d-flex flex-column align-items-center"}>

                        <BookizonPlusLogo/>

                        <h1 className={"font-weight-bold h3 my-3"}>
                            Più servizi. Più comodità. La stessa app.
                        </h1>
                        <p className={"lead mb-4"} style={{opacity: 0.9}}>
                            Bookizon Plus nasce dalla nostra visione: mettere le persone al centro, ascoltarle e
                            accompagnarle con strumenti digitali utili, umani e costruiti per semplificare la
                            quotidianità.
                        </p>
                        <div className={"d-flex align-items-baseline justify-content-center mb-3"}>
                            <span className={"display-4 font-weight-bold mr-2"}>5,99€</span>
                            <span className={"text-uppercase font-weight-bold small"}
                                  style={{letterSpacing: "0.08em", opacity: 0.85}}>
                            all&apos;anno
                        </span>
                        </div>
                        <div className={"small"}>
                            Paghi con carta e disdici quando vuoi senza alcun vincolo, nessuna sorpresa o prezzi
                            nascosti.
                        </div>
                    </section>

                    <button
                        className={"btn btn-light text-primary font-weight-bold rounded-pill px-4 py-2 shadow mb-4"}
                        onClick={this.handleActivate}
                    >
                        Attiva Bookizon PLUS <FaSolidIcon name={"plus"} className={"ml-1"}/>
                    </button>

                    <section className={"card w-100 border-0 shadow-sm mb-4"} style={benefitsCardStyle}>
                        <div className={"card-body"}>
                            <h2 className={"h4 font-weight-bold text-center text-md-left mb-3"}>Con Bookizon Plus
                                puoi</h2>
                            <ul className={"list-unstyled mb-0"}>
                                {
                                    BOOKIZON_PLUS_BENEFITS.map(b => <li className={"d-flex align-items-start mb-3"}>
                                        <FaSolidIcon name={"check-circle"} className={"mr-3 mt-1"}
                                                     style={benefitIconStyle}/>
                                        <span>{b}</span>
                                    </li>)
                                }
                            </ul>
                        </div>
                    </section>


                    <section className={"text-center"}>
                        <button
                            className={"btn btn-light text-primary font-weight-bold rounded-pill px-4 py-2 shadow"}
                            onClick={this.handleActivate}
                        >
                            Attiva Bookizon PLUS <FaSolidIcon name={"plus"} className={"ml-1"}/>
                        </button>
                        <br/>
                        <button
                            className={"btn btn-link text-white mt-5"}
                            onClick={this.props.onDismiss}
                        >
                            Torna alla home
                        </button>
                    </section>
                </div>
            </Page>
        );
    }
}

BookizonPlusPromoPage.propTypes = {
    active: PropTypes.bool,
    onDismiss: PropTypes.func
};

BookizonPlusPromoPage.defaultProps = {
    active: false,
    onDismiss: () => {
    }
};
